<template>
  <div class="tab-container">
    <ul v-if="moreThanOnePosts">
      <li v-for="(post, index) in posts" :key="index">
        <a @click.prevent="setActive(post.id)" :class="{ active: isActive(post.id) }" :href="`#${post.id}`">{{ post.title[language] }}<span class="tab-separator" v-if="index < posts.length - 1">/</span></a>
      </li>
    </ul>
    <div class="tab-content-container">
      <!-- <div class="tab-content" v-for="post in posts" :key="post.id" v-html="parseContent(post.body[language])" v-show="isActive(post.id)" :id="post.id"> -->
      <transition-group name="slide">
        <div class="tab-content" v-for="post in posts" :key="post.id" v-show="isActive(post.id)" :id="post.id">
          <PostView :id="post.id" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import * as parserRegexes from '@/views/content-parser-regexes';
import PostView from '@/views/PostView.vue';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';

export default {
	name: 'TabContentThumbnail',
	mixins: [featureSetLoaderMixin],
	components: {
		PostView,
	},
	props: {
		posts: {
			type: Array,
			required: false,
		},
		language: {
			type: String,
			validator(d) {
				return typeof d === 'string';
			},
			required: true,
		},
	},
	data() {
		return {
			activeItem: this.posts[0].id,
		};
	},
	computed: {
		moreThanOnePosts() {
			if (this.featureSet.postsView.tab.noTitleIfOne) {
				return this.posts.length > 1;
			}
			return true;
		},
	},
	methods: {
		parseContent(a) {
			let newContent = a;
			Object.keys(parserRegexes).forEach((pName) => {
				newContent = newContent.replace(parserRegexes[pName], '');
			});
			return newContent;
		},
		isActive(menuItem) {
			return this.activeItem === menuItem;
		},
		setActive(menuItem) {
			this.activeItem = menuItem;
		},
	},
};
</script>

<style src="@/styles/components/TabContentThumbnail/TabContentThumbnail.less" lang="less" scoped></style>

